<template>
  <div class="min-h-screen bg-gray-900 text-white">
    <Header v-if="isAuthenticated" />
    
    <main class="pt-16">
      <router-view v-if="!isLoading"></router-view>
      <div v-else class="flex justify-center items-center min-h-screen">
        <svg class="animate-spin h-8 w-8 text-primary" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </div>
    </main>
  </div>
</template>

<script>
import { onMounted, onBeforeMount, computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Header from './components/Header.vue';

export default {
  name: 'App',
  components: {
    Header
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const isLoading = ref(true);

    onBeforeMount(async () => {
      try {
        // Check authentication before mounting
        const token = localStorage.getItem('token');
        if (token) {
          store.commit('setToken', token);
          const user = JSON.parse(localStorage.getItem('user'));
          if (user) {
            store.commit('setUser', user);
          }
          
          // Wait for auth check to complete
          const isAuth = await store.dispatch('checkAuth');
          
          if (!isAuth && router.currentRoute.value.meta.requiresAuth) {
            router.push('/login');
          }
        }
      } catch (error) {
        console.error('Auth initialization error:', error);
      } finally {
        isLoading.value = false;
      }
    });

    return {
      isLoading,
      isAuthenticated: computed(() => store.getters.isAuthenticated),
      isAdmin: computed(() => store.getters.isAdmin)
    };
  }
};
</script> 